module.exports = __webpack_public_path__ + "static/media/code-img.56b080aa.jpg";